import { render, staticRenderFns } from "./SettingsShowIf.vue?vue&type=template&id=c79a4b56&scoped=true"
import script from "./SettingsShowIf.vue?vue&type=script&lang=js"
export * from "./SettingsShowIf.vue?vue&type=script&lang=js"
import style0 from "./SettingsShowIf.vue?vue&type=style&index=0&id=c79a4b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a4b56",
  null
  
)

export default component.exports